import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { AuthStateService } from '../auth/auth-state.service';

const RETURN_URL_KEY = 'auth.returnUrl';

export const authGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> => {
  const authService = inject(AuthService);
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (authState.isAuthenticated()) {
    return of(true);
  }

  return authService.isAuthenticatedGetAuthSession().pipe(
    map((session) => {
      if (session) {
        authState.setSession(session);

        const returnUrl = localStorage.getItem(RETURN_URL_KEY);
        if (returnUrl) {
          localStorage.removeItem(RETURN_URL_KEY);
          router.navigateByUrl(returnUrl);
        }

        return true;
      } else {
        localStorage.setItem(RETURN_URL_KEY, state.url);
        authService.federatedSignIn();
        return false;
      }
    }),
  );
};
